import type { ReactNode } from "react";
import { AlertTriangle, CheckCircle2, Info } from "lucide-react";
import { cn } from "@/lib/utils";

interface SummaryBannerProps {
  tone: "success" | "warning" | "info";
  title: string;
  body?: string;
  action?: ReactNode;
}

const ICONS = { success: CheckCircle2, warning: AlertTriangle, info: Info } as const;

/** One-line status above a table or list: "12 medarbetare redo", "2 behöver rättas". */
export function SummaryBanner({ tone, title, body, action }: SummaryBannerProps) {
  const Icon = ICONS[tone];
  return (
    <div
      role="status"
      className={cn(
        "flex flex-wrap items-center gap-3 rounded-g-md px-4 py-3",
        tone === "success" && "bg-g-success-tint text-g-success",
        tone === "warning" && "bg-g-warning-tint text-g-warning",
        tone === "info" && "bg-g-info-tint text-g-info",
      )}
    >
      <Icon className="h-5 w-5 shrink-0" aria-hidden="true" />
      <span className="flex min-w-0 flex-1 flex-col">
        <span className="text-[14px] font-bold">{title}</span>
        {body ? <span className="text-[12.5px] text-g-ink-600">{body}</span> : null}
      </span>
      {action}
    </div>
  );
}
